import React, { useMemo } from 'react';
import {
  arrayOf, bool, exact, func, string, number,
} from 'prop-types';
import { Flex } from '@atoms';
import { MenuCategory } from '@molecules';
import { Menu } from '@templates';

const MenuCategories = ({
  hasServerError,
  onToastClose,
  onCategorySelect,
  categories,
  subcategories,
}) => {
  const memoizedСategories = useMemo(() => (
    categories.map(({
      title, imageSrc, id, isActive,
    }) => (
      <MenuCategory
        key={id}
        isActive={isActive}
        title={title}
        imageSrc={imageSrc}
        onCategorySelect={onCategorySelect(id)}
      />
    ))
  ), [categories]);

  return (
    <Menu
      isSubcategoryBarVisible={false}
      hasBackToTopButton
      hasBackUpButton={false}
      hasServerError={hasServerError}
      onToastClose={onToastClose}
      categories={categories}
      subcategories={subcategories}
      onCategorySelect={onCategorySelect}
    >
      <Flex wrapFlex>
        {memoizedСategories}
      </Flex>
    </Menu>
  );
};

MenuCategories.propTypes = {
  hasServerError: bool.isRequired,
  onToastClose: func.isRequired,
  onCategorySelect: func.isRequired,
  categories: arrayOf(exact({
    title: string,
    imageSrc: string,
    isActive: bool,
    id: number,
  })).isRequired,
  subcategories: arrayOf(exact({
    title: string,
    id: number,
  })).isRequired,
};

export default MenuCategories;
